import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Box, Button } from "@mui/material";
import host,{Host} from "../../../../assets/js/Host";
import { toast } from "react-toastify";
export default function VerificationStep(props) {
  const [loading, setLoading] = useState(false);
  function onChange(value) {
    console.log("Captcha value:", value);
    if (value) {
      props?.setRecaptchaValue(value);
      props?.setIsCapatchTreu(true);
    } else {
      props?.setRecaptchaValue(null);
      props?.setIsCapatchTreu(false);
    }
  }
  try {
    const capatch = props?.captchaRef?.current?.querySelector(
      "#recaptcha-anchor-label"
    );
    if (capatch) {
      capatch.textContent = "أنا لست روبوتًا";
    }
  } catch (e) {}

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        paddingTop: "80px",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Box
        sx={{
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          paddingTop: "80px",
          flexDirection: "column",
          gap: "10px",
          backgroundColor: "#fff",
          boxShadow: " 0 0 7px -2px #ac9f9f",
          padding: "70px 25px",
          borderRadius: "3px",
        }}
      >
        <ReCAPTCHA
          ref={props?.captchaRef}
          sitekey={Host.CAPATCHA_SECRET_KEY}
          onChange={onChange}
          hl="ar"
        />
        <span>يرجى الانتظار بينما يتم تحميل CAPATCHA</span>
        <Button
          onClick={props?.reloadCapatcha}
          sx={{
            backgroundColor: "#1e6a99",
            color: "#fff",
            fontFamily:'Cairo'
          }}
        >
          اعادة تحميل CAPATCHA
        </Button>
      </Box>
    </Box>
  );
}
